export default __webpack_public_path__ + "static/media/r6.7b2e7c12.jpg";